import { jsx as r, jsxs as _ } from "react/jsx-runtime";
import { Stack as O, useTheme as z, Box as f, Typography as x } from "@mui/material";
import '../../assets/ScheduleCalendar.css';const w = "_Month_mzzxr_1", N = "_Header_mzzxr_7", W = "_Cell_mzzxr_18", v = "_Grid_mzzxr_23", S = "_Item_mzzxr_35", R = "_Day_mzzxr_42", c = {
  Month: w,
  Header: N,
  Cell: W,
  Grid: v,
  Item: S,
  Day: R
}, b = 20, J = ({ year: s, items: y, startMonthIndex: g = 0 }) => /* @__PURE__ */ r(O, { gap: 2, children: H.filter((n) => n.i >= g).map((n) => {
  const a = y.filter((u) => u.start.getMonth() <= n.i && u.end.getMonth() >= n.i);
  return /* @__PURE__ */ r(G, { month: n, year: s, items: a }, n.label);
}) }), G = ({ month: s, year: y, items: g }) => {
  const n = z();
  let a = new Date(y, s.i, 1), u = s.i, i = [];
  for (; u === s.i; ) {
    let t, e = new Date(a);
    if (i.length === 0) {
      const d = M(a);
      t = { weekIndex: 0, items: g.filter((l) => l.start <= a && l.end >= a || l.start >= a && l.start <= d), days: [{ dayOfWeekIndex: a.getDay(), date: e, dayOfMonth: a.getDate() }] }, i.push(t);
    } else if (e.getDay() === 1) {
      const d = M(a), o = g.filter((l) => l.start <= a && l.end >= a || l.start >= a && l.start <= d);
      t = { weekIndex: i.length, items: o, days: [{ dayOfWeekIndex: a.getDay(), date: e, dayOfMonth: a.getDate() }] }, i.push(t);
    } else
      i[i.length - 1].days.push({ dayOfWeekIndex: a.getDay(), date: e, dayOfMonth: a.getDate() });
    a.setDate(a.getDate() + 1), u = a.getMonth();
  }
  return /* @__PURE__ */ _(O, { className: c.Month, children: [
    /* @__PURE__ */ _(f, { className: c.Header, children: [
      /* @__PURE__ */ r(x, { variant: "h3", children: s.label }),
      /* @__PURE__ */ r(f, { className: c.Grid, children: I.map((t) => /* @__PURE__ */ r(f, { className: c.Cell, children: /* @__PURE__ */ r(x, { variant: "body2", children: t.label }) }, t.label)) })
    ] }),
    /* @__PURE__ */ _(f, { className: c.Grid, children: [
      i.map((t) => I.map((e) => {
        var l;
        const d = t.days.find((h) => h.dayOfWeekIndex === e.i), o = b * (((l = t.items) == null ? void 0 : l.length) > 0 ? t.items.length + 1 : 2) + 15;
        return d ? /* @__PURE__ */ r(f, { className: c.Cell, style: {
          gridColumn: e.i === 0 ? 7 : e.i,
          gridRow: t.weekIndex + 2,
          height: `${o}px`
        }, children: /* @__PURE__ */ r(x, { className: c.Day, children: d.dayOfMonth }) }, `day_${d.dayOfMonth}`) : /* @__PURE__ */ r(f, { className: c.Cell, style: {
          gridColumn: e.i === 0 ? 7 : e.i,
          gridRow: t.weekIndex + 2,
          height: `${o}px`
        } }, `empty_${e.i}`);
      })),
      i.map((t) => !t.items || t.items.length === 0 ? null : t.items.map((e, d) => {
        const o = t.days[0].date, l = t.days[t.days.length - 1].date;
        let h = 1, p = 7;
        if (e.start > o && (h = e.start.getDay() === 0 ? 7 : e.start.getDay()), e.end <= l && (p = e.end.getDay() === 0 ? 7 : e.end.getDay()), t.weekIndex === 0) {
          const m = o.getDay() === 0 ? 7 : o.getDay();
          h < m && (h = m);
        }
        if (t.weekIndex === i.length - 1) {
          const m = l.getDay() === 0 ? 7 : l.getDay();
          p > m && (p = m);
        }
        const C = p - h + 1, $ = b * (d + 1) + 10;
        let D = 0, k = 0;
        return e.start >= o && (D = b / 2), e.end <= l && (k = b / 2), /* @__PURE__ */ r("div", { className: c.Item, onClick: e.onClick, style: {
          gridColumn: `${h} / span ${C}`,
          backgroundColor: e.color,
          gridRow: t.weekIndex + 2,
          transform: `translateY(${$}px)`,
          height: b - 3,
          borderRadius: `${D}px ${k}px ${k}px  ${D}px`,
          cursor: e.onClick ? "pointer" : void 0
        }, children: /* @__PURE__ */ r(x, { variant: "caption", sx: { color: e.color ? n.palette.getContrastText(e.color) : void 0 }, children: e.title }) }, `${t.weekIndex}_${e.id}`);
      }))
    ] })
  ] });
}, H = [
  { label: "January", i: 0 },
  { label: "February", i: 1 },
  { label: "March", i: 2 },
  { label: "April", i: 3 },
  { label: "May", i: 4 },
  { label: "June", i: 5 },
  { label: "July", i: 6 },
  { label: "August", i: 7 },
  { label: "September", i: 8 },
  { label: "October", i: 9 },
  { label: "November", i: 10 },
  { label: "December", i: 11 }
], I = [
  { label: "Mo", i: 1 },
  { label: "Tu", i: 2 },
  { label: "We", i: 3 },
  { label: "Th", i: 4 },
  { label: "Fr", i: 5 },
  { label: "Sa", i: 6 },
  { label: "Su", i: 0 }
];
function M(s) {
  const y = s.getDay(), g = y === 0 ? 0 : 7 - y, n = new Date(s);
  return n.setDate(s.getDate() + g), n;
}
export {
  G as Month,
  J as ScheduleCalendar
};
//# sourceMappingURL=ScheduleCalendar.js.map
